import React, { useState, useEffect, useContext, useRef } from "react";
import UserRow from "../user/UserRow";
import "./Stage.scss";
import TaskCard from "../task/TaskCard";
import UserInfoCard from "../user/UserInfoCard";
import Split from "@uiw/react-split";
import PopUpWindow from "../popUpWindow/PopUpWindow";
import TaskDetails from "../task/TaskDetails";
import dashboardApi from "../../services/dashboardApi";
import { AuthContext } from "../../context/AuthContext";
import { convertTimeToISO, findEndTime } from "../../utils/common";
import { format } from "date-fns";
import { UserRolesEnum,ROStatusEnum} from "../../enum/enums";

const StageUsers = ({triggerStatusBarReload}) => {
  const { manageTimeSlots, timeSlots, slotUnitWidth, dateChange, user } = useContext(AuthContext);
  const firstElementRef = useRef(null);
  const [unitWidth, setUnitWidth] = useState();
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  const [data, setData] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  useEffect(() => {
    if (firstElementRef.current) {
      const width = firstElementRef.current.getBoundingClientRect().width;
      setUnitWidth(width);
    }
  }, [data, timeSlots]);

 

  

 
  const checkAllowDrop = (slot) => {
    if (slot.break) {
      return false;
    } else {
      return true;
    }
  };

  
  const [ShowPopup, setShowPopup] = useState(false);
  const openPopup = async(task, selectedUser) => {   
    
    const userRole = user?.userRole;
    if(userRole === UserRolesEnum.TECHINICIAN){
      if(selectedUser._id!=user._id){
        return false;
      }
      let startOfTodayUTC = new Date();
      startOfTodayUTC.setUTCHours(0, 0, 0, 0); // Set to 12:00 AM UTC
      const filterDate = new Date(dateChange);

      if(filterDate < startOfTodayUTC) {
        return false;
      }
    }
    const response = await dashboardApi.getRepairORder(task.repairOrderId)    
    if(response.data.ok){
      const orderStatus=response.data.repairOrder[0].roStatus;
      if(orderStatus != ROStatusEnum.COMPLETED){
    setSelectedTask(task);  // Store task data
    setSelectedUser(selectedUser);
    setShowPopup(!ShowPopup);}
      }
  };
  const closePopup = () => {
    setShowPopup(false);    // Close popup
    setSelectedTask(null);  // Clear selected task data
    setSelectedUser(null); 
  };
  const [error, setError] = useState(null);
  const [viewLoader, setViewLoader] = useState(false);
  

  const fetchData = async () => {
    try {
      const dateValue = dateChange.toISOString();
      setData(null);
      const response = await dashboardApi.gettechniciandailyschedules(dateValue);
      manageTimeSlots(response.data.technicianDailySchedules[0]?.slots);
      const transformedOptions = [{
          id: "001",
          stageName: "allUsers",
          users:response.data.technicianDailySchedules
        }
       
      ]
       setData(transformedOptions);
    } catch (error) {
    } finally {
    }
  };
  useEffect(() => {  
    fetchData();
  }, [dateChange]);

  const findNextSlotWithTask = (currentIndex, user) => {
    
    let indx;


    if(user.slots[currentIndex].task[0]?.duration > 1){
      indx = currentIndex + user.slots[currentIndex].task[0]?.duration
    }else{
      indx = currentIndex + 1
    }

    
    
    for (
      let i = indx + 1;
      i < user.slots.length;
      i++
    ) {
      if (user?.slots[i]?.allocated || user?.slots[i]?.break) {
        return i - indx; 
      }
    }
    return 0; 
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div className="timeRow">
          <div className="time"></div>
          <div className="timeline">
            {timeSlots?.map((slot, index) => (
              <div className={slot.break ? "timeColumn break" : "timeColumn"}>
                {slot.time}
              </div>
            ))}
          </div>
        </div>
        {data?.map((stage, stageIndex) => (
            <div
              className="w-100 stage-wrap"
              style={
                {
                }
              }
            >
              <div className="stages" key={stageIndex}>
                
                <div>
                  {stage.users?.map((user, userIndex) => (
                    <div
                      className={
                        user.leaveStatus === "off"
                          ? "userRow onLeave"
                          : "userRow"
                      }
                    >
                      <div className="userDetails">
                        <UserInfoCard user={user} />
                      </div>
                      <div className="timeline">

                        {user.slots?.map((slot, index) => {
                          

                          const slotsUntilNextTask =
                            findNextSlotWithTask(index, user);

                          return (
                            <div
                              key={index}
                              ref={index === 0 ? firstElementRef : null}
                              className={
                                !checkAllowDrop(slot)
                                  ? "timeColumn break"
                                  : "timeColumn"
                              }
                            >
                              <UserRow
                                key={userIndex}
                                stage={stage}
                                time={slot}
                                user={user}
                                allowDrop={false}
                              >
                                {Object.keys(slot.task).length !== 0 &&
                                  unitWidth && (
                                    <TaskCard
                                      unitWidth={unitWidth}
                                      task={slot.task[0]}
                                      showStage={true}
                                      stage={stage}
                                      user={user}
                                      slotsUntilNextTask={slotsUntilNextTask > 0 ? slotsUntilNextTask : 0}
                                      fromUserList={true}
                                      onClick={() => openPopup(slot.task[0], user)}
                                    />
                                  )}
                              </UserRow>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
      </div>
      {ShowPopup && (
        <PopUpWindow closePopup={closePopup}>
          <TaskDetails task={selectedTask} userdetails={selectedUser} refetchData={fetchData} closePopup={closePopup} triggerStatusBarReload={triggerStatusBarReload} parent='UserList'/>
        </PopUpWindow>
      )} 
    </div>
  );
};

export default StageUsers;
